module.exports = __webpack_public_path__ + "static/media/black-friday-poster-sample.897b60fb.png";